import { IconProps } from '.';

function UploadIcon({ style, className }: IconProps) {
  return (
    <svg
      width='24'
      height='16'
      viewBox='0 0 24 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <title>UploadIcon</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.43747 1.12996C7.42492 2.04457 5.96375 3.85331 5.46987 6.00408C3.12212 5.62972 0.819108 7.08675 0.171026 9.45316C-0.524448 11.9967 0.954776 14.6268 3.47582 15.3295C3.85116 15.4326 4.23394 15.4897 4.61897 15.4998L18.494 15.5C21.5351 15.5 24 13.0135 24 9.9456C24 6.91936 21.6016 4.4588 18.6175 4.39256C16.9243 1.02268 12.8859 -0.438434 9.43747 1.12996ZM11.4993 14.4912H4.63197C4.34028 14.4834 4.03702 14.4381 3.74041 14.3566C1.75325 13.8028 0.586365 11.728 1.13497 9.7216C1.68446 7.7152 3.74227 6.53746 5.73082 7.09167C6.01928 7.17207 6.31266 6.98056 6.35816 6.68217C6.66943 4.64067 7.98279 2.89748 9.84834 2.04967C12.8927 0.665049 16.4727 2.03185 17.8462 5.10302C17.927 5.28378 18.1054 5.39999 18.302 5.39999H18.494C20.9828 5.39999 23 7.43486 23 9.9456C23 12.4563 20.9828 14.4912 18.494 14.4912H12.4993V8.39668L15.1457 11.3373L15.215 11.4016C15.4098 11.5516 15.6792 11.5301 15.8528 11.3373C16.0481 11.1203 16.0481 10.7686 15.8528 10.5516L12.3528 6.66271L12.2836 6.59843C12.0887 6.44843 11.8193 6.46986 11.6457 6.66271L8.14571 10.5516L8.08785 10.6285C7.95286 10.8451 7.97214 11.1444 8.14571 11.3373L8.21496 11.4016C8.40982 11.5516 8.67925 11.5301 8.85281 11.3373L11.4993 8.39668V14.4912Z'
        fill='#33820D'
      />
    </svg>
  );
}

export default UploadIcon;
